var JavascriptMixin = {
  methods: {
    scrollToElementById(id) {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView();
      }
    },
    scrollToElement(classElement) {
      const el = this.$el.getElementsByClassName(classElement)[0];
      if (el) {
        el.scrollIntoView();
      }
    },
    simulateClickById(idElement) {
      const el = document.getElementById(idElement);
      if (el) {
        el.click();
      }
    }
  }
};
export default JavascriptMixin;